<!-- 温控器实时读数+控制 -->
<template>
    <div class='container containerBox'>
        <div class="detail-box equient-detail-box">
            <div class="detail-subtitle">基本信息
                <el-button class="fr" style="margin-right:20px;" @click="refresh" size="mini" type="primary" icon="el-icon-refresh" plain>刷新数据</el-button>
            </div>
            <div class="detail-item">
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计序列号：</span><span>{{modelData.deviceSerial}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计类型：</span><span>{{modelData.deviceType}}</span>
                    </el-col>
                     <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计型号：</span><span>{{modelData.deviceModel}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>在线状态：</span><span>{{fmtOnlineStatus(modelData.status)}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>运行状态：</span><span>{{modelData.linkStatus}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>故障状态：</span><span>{{modelData.sysStatusResult}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>供冷/供热：</span><span>{{modelData.modeStatus}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>余额状态：</span><span>{{modelData.balanceAlarm}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>使用状态：</span><span>{{modelData.disabled}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>计费状态：</span><span>{{modelData.allowCharging}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>模式：</span><span>{{modelData.factoryMode}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>累计读数：</span><span>{{modelData.fcuCounter}}</span>
                    </el-col>
                </el-row>
            </div>
            <div class="detail-subtitle">风盘信息</div>
            <div class="detail-item">
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>地暖阀：</span><span>{{modelData.hasFloorHeating}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>水阀状态：</span><span>{{modelData.valve1On + '' + modelData.valve2On}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>风速：</span><span>{{`${modelData.fcuHighSpeed}${modelData.fcuLowSpeed}${modelData.fcuMediumSpeed}`}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>计量状态：</span><span>{{modelData.fcuInCounting}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>故障情况：</span><span>{{faultMsgStr}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>当月费用：</span><span>{{baseData.monthly_fee_int + '元'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>当前余额：</span><span>{{baseData.current_balance_int+ '元'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>查询设定：</span><span>{{fmtStr_0_1(baseData.allow_query, '不可查询','可查询')}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>通讯中断判定时间：</span><span>{{baseData.link_down_threshold + 'min'}}</span>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>电机功率：</span><span>{{baseData.fcu_motor_power + 'W'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>高档制冷量：</span><span>{{baseData.high_capacity + 'W'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>中档制冷量：</span><span>{{baseData.medium_capacity + 'W'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>低档制冷量：</span><span>{{baseData.low_capacity + 'W'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>地暖盘管换热量：</span><span>{{baseData.floor_heating_capacity + 'W'}}</span>
                    </el-col>
                </el-row>
            </div>
            <div class="detail-subtitle">温控器参数</div>
            <div class="detail-item noborder">
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>开关机：</span><span>{{funFmtWKQParmas(baseData.setting_power_on).powerOn()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>模式：</span><span>{{funFmtWKQParmas(baseData.setting_mode).settingMode()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>风速：</span><span>{{funFmtWKQParmas(baseData.setting_speed).settingSpeed()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>温度：</span><span>{{baseData.setting_temperature/10 + '℃'}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>键盘锁定：</span><span>{{funFmtWKQParmas(baseData.setting_key_lock).setting_key_lock()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>来电启动：</span><span>{{funFmtWKQParmas(baseData.setting_op_at_acback).setting_op_at_acback()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>风扇模式使能：</span><span>{{funFmtWKQParmas(baseData.setting_allow_ventilation).setting_enable_fanonly()}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>温度设置：</span><span>{{`上限${baseData.setting_temperature_ul}/下限${baseData.setting_temperature_dl}`}}</span>
                    </el-col>
                </el-row>
                
            </div>

            <cmp-control-form :controlType="1" :terminalid="terminalid"></cmp-control-form>
        </div>
    </div>
</template>

<script>
import CmpControlForm from './CmpControlForm'
import fmtDeviceData from '../EquipmentInfo.js'
import Service from '@/api/Service'
import { funFmtWKQParmas, funFmtOnlineStatus } from '@/utils/utils'
let Timer;
let COUNT = 1;

export default {
    name:  'equipmentwkqcontrol',
    data() {
        return {
            modelData: {},
            terminalid: '',
        };
    },
    components:{
        CmpControlForm
    },
    computed: {
        baseData() {
            return this.modelData._data || {}
        },
        faultMsgStr() {
            if(!this.modelData.faultMsg) return this.modelData.sysStatusResult
            return this.modelData.faultMsg.join('、')
        },
    },
    mounted() {
        // Timer = setInterval(() => {
        //     this.getInfo(this.$route.params.terminalid);
        // }, 5000);
        this.terminalid = this.$route.params.terminalid
    },
    destroyed() {
        COUNT = 1;
        clearTimeout(Timer);
    },
    created() {
        this.getInfo(this.$route.params.terminalid)
    },

    methods: {
        funFmtWKQParmas,
        // 获取表计当前读数
        async getInfo(oid) {
            COUNT++
            Service.getTerminalInfo({oid: oid}).then(data=> {
               if(data) {
                    data = data === 'success' ? [] : data;
                    let equientInfo = fmtDeviceData(data);
                    this.modelData = equientInfo.WKQ[0];

                    if(COUNT>20) {
                        clearTimeout(Timer);
                        return
                    }else{
                        Timer = setTimeout(() => {
                            this.getInfo(this.$route.params.terminalid);
                        }, 6000);
                    }
                }
            })
        },

        async refresh() {
            clearTimeout(Timer);
            await this.getInfo(this.$route.params.terminalid);
            this.$message({
                message: '刷新成功',
                type: 'success'
            });
        },

        fmtStr_0_1(status, str1, str2) {
            if (status === 0) {
                return str1 || ''
            }
            if (status === 1) {
                return str2 || ''
            }
        },
        // 格式化在线状态
        fmtOnlineStatus(status) {
            return funFmtOnlineStatus(status);
        },

    }
}

</script>
<style lang='less' scoped>
.detail-box{
    margin-right: 300px;
    border-right: 1px solid #ccc;
    position: relative;
    min-height: 600px;
    .detail-subtitle{
        font-size: 16px;
        color: @font-color;
        font-weight: 400;
        margin-bottom: 10px;
    }
    .detail-item{
        border-bottom: 1px solid #ccc;
        margin: 0 20px 10px 0;
        padding: 0 0 20px 20px;
        &.noborder{
            border-bottom: none;
        }
    }
}
</style>
